module.exports = __webpack_public_path__ + "img/chatbot-error.db49d865.png";